import * as React from 'react'

import { Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface CardsNotAvailableModalProps {
  onClose: () => void
}

const CardsNotAvailableModal = ({ onClose }: CardsNotAvailableModalProps) => (
  <Modal
    title={i18n.t('expenses_v2.cards.actions.modal.cards_not_available.title')}
    illustration="lightbulb"
    onClose={onClose}
    footer={<Button onClick={onClose}>{i18n.t('expenses_v2.buttons.ok_thanks')}</Button>}
  >
    <Text.Normal color="grey800">
      {i18n.t('expenses_v2.cards.actions.modal.cards_not_available.description')}
    </Text.Normal>
  </Modal>
)

export default CardsNotAvailableModal
